import { TurboModuleRegistry } from 'react-native';
export default TurboModuleRegistry.get('RNPerformanceManager');
//# sourceMappingURL=NativeRNPerformanceManager.js.map